import { combineReducers } from 'redux';
import addressReducer from './Address/store/addressReducer';
import contactReducer from './Contact/store/contactReducer';
import projectReducer from './Projects/store/projectReducer';

export const reducers = combineReducers({
    address: addressReducer,
    contact: contactReducer,
    projects: projectReducer
});